import ActionButton from "@/components/library/buttons/ActionButton";

import Modal from "../../Modal";

import redirectToAvailabilitySearchUrl from "@/components/common/modals/AdaAvailabilityNoticeModal/actions/redirectToAvailabilitySearchUrl";

import { useTranslations } from "next-intl";
import "./index.scss";

interface AdaAvailabilityNoticeModalProps {
  availabilitySearchUrl: string;
  onClose: () => void;
  onConfirm: () => void;
}

const AdaAvailabilityNoticeModal = (props: AdaAvailabilityNoticeModalProps) => {
  const t = useTranslations("AdaAvailabilityNoticeModal");

  return (
    <Modal
      className="component ada-availability-notice-modal"
      onClose={props.onClose}
      title=""
      width={600}
    >
      <div className="ada-availability-notice-modal-container">
        <div className="ada-availability-notice-modal-message">
          <div className="header">{t("notice")}</div>
          <p>
            <b>{t("room-has-disability-features")}</b>
          </p>
          <p>{t("book-only-if-useful")}</p>
        </div>
        <div className="ada-availability-notice-modal-actions">
          <form
            action={redirectToAvailabilitySearchUrl.bind(
              null,
              props.availabilitySearchUrl
            )}
          >
            <ActionButton precedence="SECONDARY">
              {t("book-a-different-room")}
            </ActionButton>
            <ActionButton type="button" onClick={props.onConfirm}>
              {t("book-this-room")}
            </ActionButton>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default AdaAvailabilityNoticeModal;
